import {
  IWidgetMachineListState,
  MachineDashboardWidgetId,
  PERIOD_INDEPENDENT_MACHINE_DASHBOARD_WIDGET_IDS,
} from '../../types/machineDashboardWidgetListState.types';
import { IMachineDashboardState, NoSiteMachine } from '../../types/machineDashboardState.types';
import {
  ManualMachineDashboard,
  MachinesReport,
  Site,
} from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';
import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';
import { Optional } from 'lib/types/Optional';

const selectMachineDashboardState = (state: IState): IMachineDashboardState =>
  state.modules.cleaning.widgets['machine-dashboard'];

export class MachineDashboardSelectors {
  public static selectManualMachineDashboardData = (state: IState): Optional<ManualMachineDashboard> =>
    selectMachineDashboardState(state).manualMachineDashboard.data;

  public static selectManualMachineDashboardIsLoading = (state: IState): Optional<boolean> =>
    selectMachineDashboardState(state).manualMachineDashboard.isLoading;

  public static selectIsPeriodIndependentWidgetListsLoading = (state: IState): boolean =>
    PERIOD_INDEPENDENT_MACHINE_DASHBOARD_WIDGET_IDS.some(
      widgetId => selectMachineDashboardState(state).widgetLists[widgetId].isLoading
    );

  public static selectWidgetListState =
    (widgetId: MachineDashboardWidgetId) =>
    (state: IState): IWidgetMachineListState =>
      selectMachineDashboardState(state).widgetLists[widgetId];

  public static selectWidgetListMachines =
    (widgetId: MachineDashboardWidgetId) =>
    (state: IState): MachinesReport[] =>
      selectMachineDashboardState(state).widgetLists[widgetId].machines;

  public static selectWidgetListThumbnailUrlsByMachineId =
    (widgetId: MachineDashboardWidgetId) =>
    (state: IState): Record<string, string> =>
      selectMachineDashboardState(state).widgetLists[widgetId].thumbnailUrlsByMachineId;

  public static selectWidgetListIsLoading =
    (widgetId: MachineDashboardWidgetId) =>
    (state: IState): boolean =>
      selectMachineDashboardState(state).widgetLists[widgetId].isLoading;

  public static selectWidgetListIsLoadingMore =
    (widgetId: MachineDashboardWidgetId) =>
    (state: IState): boolean =>
      selectMachineDashboardState(state).widgetLists[widgetId].isLoadingMore;

  public static selectWidgetListHasMore =
    (widgetId: MachineDashboardWidgetId) =>
    (state: IState): boolean =>
      selectMachineDashboardState(state).widgetLists[widgetId].hasMore;

  public static selectSitesListData = (state: IState): Optional<Site[]> =>
    selectMachineDashboardState(state).sitesList.data;

  public static selectSitesListIsLoading = (state: IState): boolean =>
    selectMachineDashboardState(state).sitesList.isLoading;

  public static selectNoSiteMachinesData = (state: IState): Optional<NoSiteMachine[]> =>
    selectMachineDashboardState(state).noSiteMachines.data;

  public static selectNoSiteMachinesIsLoading = (state: IState): boolean =>
    selectMachineDashboardState(state).noSiteMachines.isLoading;
}
